import React from 'react';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';
import { FieldPath, FieldValues, Control } from 'react-hook-form';
import { AppName, AppNameProvider } from '@m43/core';
import { EventPanelNewEventNarrativeInput } from '../../additional-infos/event-panel-additional-infos/event-panel-new-event-narrative-input';

type NewEventNarrativeInputProps = Pick<
    React.ComponentProps<typeof EventPanelNewEventNarrativeInput>,
    'onReplaceVehicles' | 'onLexicalError' | 'mode'
>;

type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    narrativeInputProps?: NewEventNarrativeInputProps;
};

export function FormNewEventNarrativeInput<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { narrativeInputProps, ...integratedFormControlProps } = props;

    const narrativeInputPropsMemo = React.useMemo(() => narrativeInputProps ?? {}, [
        narrativeInputProps,
    ]);

    return (
        <AppNameProvider appName={AppName.CAD_NEXT}>
            <IntegratedFormControl {...integratedFormControlProps} renderViewMode={() => undefined}>
                {() => (
                    <EventPanelNewEventNarrativeInput
                        control={
                            integratedFormControlProps.control as Control<FieldValues, unknown>
                        }
                        fieldName={integratedFormControlProps.name}
                        {...narrativeInputPropsMemo}
                    />
                )}
            </IntegratedFormControl>
        </AppNameProvider>
    );
}
